import React, { Component } from 'react';
import authService from './../api-authorization/AuthorizeService'
import { ConfigMenu } from './../ConfigMenu'
import ReactRegionSelect from 'react-region-select';
import { FormattedMessage, injectIntl } from 'react-intl';
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import ReactQuill from 'react-quill';
import Popup from './../popup/reactjs-popup.cjs.development';
import 'reactjs-popup/dist/index.css';

export const ConfigResources = injectIntl(class extends Component {
  constructor(props) {
    super(props);
    var curDate = new Date();
    curDate.setHours(0,0,0,0);
    this.state = {
      resources: [],
      services: [],
      service: null,
      selectedImage: 0,
      loading: true,
      filters: [],
      profiles: [],
      collapsed: true,
      param: {},
      companyId: parseInt(this.props.match.params.companyId) || 0,
      resource: null,
      shouldScroll: false
    };
    this.handleNew = this.handleNew.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleNewGroup = this.handleNewGroup.bind(this);
    this.onRegionChange = this.onRegionChange.bind(this);
  }

  componentDidMount() {
    this.populateCompaniesData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.shouldScroll) {
      const target = document.getElementById(`configservices`);
      console.log(target);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
      this.setState(prevState => ({...prevState, shouldScroll: false}));
    }
  }
  
  selectResource(resource) {
    this.setState(prevState => ({...prevState, resource: resource, regions: resource.locationX!==null?[{x:resource.locationX, y:resource.locationY, width:resource.locationWidth, height:resource.locationHeight, data: {index: 0}, isChanging: false, new: false}]:[]}));
    this.populateServicesData(this.state.companyId);
  }

  async selectResourceAndScroll(e, resource) {
    e.preventDefault();
    this.setState(prevState => ({...prevState, resource: resource, regions: resource.locationX!==null?[{x:resource.locationX, y:resource.locationY, width:resource.locationWidth, height:resource.locationHeight, data: {index: 0}, isChanging: false, new: false}]:[]}));
    await this.populateServicesData(this.state.companyId);
    this.setState(prevState => ({...prevState, shouldScroll: true}));
  }

  handleNew() {
    this.setState(prevState => ({...prevState, resource: { id: 0, count: 1, images: [], companyImages:[], params: [], locationX: null }}));
  }

  async handleSaveFilterService(resourceParam) {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/resourceparamcompanyservice/${resourceParam.id}/${this.state.resource.id}/${this.state.paramservice.id}`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.state.param)
    });
    const newParam = await response.json();
    const filters = this.state.filters;

    filters.forEach(group => {
      group.items.forEach(param => {
        if (param.id === resourceParam.id) {
          param.companyServices = param.companyServices.filter(cs => cs.id !== newParam.id);
          param.companyServices.push(newParam);
        }
      });
    });
    this.setState(prevState => ({...prevState, filters: filters, param: newParam}));
  }

  async handleSaveService(service) {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/${this.state.resource.id}/service`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.state.service)
    });
    const newParam = await response.json();
    const services = this.state.services;

    services=services.filter(cs => cs.id !== service.id);
    services.push(newParam);
    this.setState(prevState => ({...prevState, services: services}));
  }

  async handleSave() {
    if (!this.state.resource.name || this.state.resource.name === '')
      return;
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/resource`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.state.resource)
    });
    const data = await response.json();
    var resources = this.state.resources;
    for (var i = 0; i < resources.length; i++)
    {
      if (resources[i].id === this.state.resource?.id)
      {
        resources[i] = this.state.resource;
        break;
      }
    }
    if (i === resources.length)
      resources.push(data);
    this.setState(prevState => ({...prevState, resource: data}));
    this.setState(prevState => ({...prevState, resources: resources}));
  }

  async handleNewGroup() {
    if (!this.state.newgroupname || this.state.newgroupname === '')
      return;
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/resourceparamgroup`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({name: this.state.newgroupname, createdCompanyId: this.state.companyId})
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, newgroupname: undefined, filters: [...prevState.filters, data]}));
  }

  async saveGroupValue(groupId) {
    if (!this.state.newgroupvalue || this.state.newgroupvalue === '')
      return;
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/resourceparam/${groupId}`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({name: this.state.newgroupvalue, createdCompanyId: this.state.companyId})
    });
    const data = await response.json();
    var filters = this.state.filters;
    filters.filter(f => f.id === groupId)[0].items.push(data);
    this.setState(prevState => ({...prevState, curparamgroup: undefined, newgroupvalue: undefined, filters: filters}));
  }

  selectService(service) {
    this.setState(prevState => ({...prevState, service: service}));
  }

  selectParamService(service, param) {
    var cs = param.companyServices.filter(cs => cs.serviceId === service.id && cs.resourceId === this.state.resource.id);
    this.setState(prevState => ({...prevState, paramservice: service, param: cs.length > 0 ? cs[0] : {}}));
  }

  addFilter(id, groupId) {
    var params = this.state.resource.params;
    if (params.map(p => p.id).includes(id)) {
        params = params.filter(f => f.id !== id);
        this.changeResourceResourceParam(id, true);
    }
    else {
      if (groupId > 0) {
        var alreadySelected = this.state.filters.filter(f => f.id === groupId)[0].items.filter(f => params.map(p => p.id).includes(f.id));
        if (alreadySelected.length > 0) {
          params = params.filter(f => f.id !== alreadySelected[0].id);
          this.changeResourceResourceParam(alreadySelected[0].id, true);
        }
      }
      params.push({id: id, optional: false});
      this.changeResourceResourceParam(id, false);
    }
    const res = this.state.resources;
    res.filter(r => r.id === this.state.resource?.id)[0].params = params;
    this.setState(prevState => ({...prevState, resource: { ...prevState.resource, params: params}}));
  }

  async changeResourceResourceParam(id, remove) {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/resourceresourceparam/${this.state.companyId}/${this.state.resource.id}/${id}`, {
      method: remove ? "DELETE" : "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      }
    });
    await response.json();
  }

  async assignResource(service) {
    service.assigned = !service.assigned;
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/${this.state.resource.id}/service`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(service)
    });
    await response.json();
    this.setState(prevState => ({...prevState, services: [...prevState.services]}));
  }

  async addFile(event) {
    var formData = new FormData();
    formData.append("file", event.target.files[0]);

    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/${this.state.resource.id}/image`, {
      method: 'POST',
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain'
      },
      body: formData
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, resource: {...prevState.resource, images: [data]}}));
  }

  async removeImage() {
    var selectedImage = this.state.selectedImage;
    this.setState(prevState => ({...prevState, selectedImage: -1}));
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/${this.state.resource.id}/image/${selectedImage}`, {
      method: 'DELETE',
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain'
      }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, resource: {...prevState.resource, images: data}, selectedImage: selectedImage >= data.length ? data.length - 1 : selectedImage}));
  }

  async upImage() {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/${this.state.resource.id}/image/${this.state.selectedImage}`, {
      method: 'PUT',
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain'
      }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, resource: {...prevState.resource, images: data}, selectedImage: 0}));
  }

  onRegionChange(val) {
    this.setState(prevState => ({...prevState, resource: {...prevState.resource, locationX: val[0].x, locationY: val[0].y, locationWidth: val[0].width, locationHeight: val[0].height}, regions: val}));
  }

  updateResourceLocation(evt) {
    const val = evt.target.value;
    //this.setState(prevState => ({...prevState, company: {...prevState.company, locationX: parseFloat(val.split(',')[0]), locationY: parseFloat(val.split(',')[1])}}));
  }

  /*toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }*/

  renderRightPanel() {
    return (
      <SideNav className="rightpanel">
        <SideNav.Toggle className="righttoggle"/>
        <SideNav.Nav className="rightcontainer" selected={this.props.selected}>
            <table class="table table-striped navbar-nav flex-grow" aria-labelledby="tabelLabel"><tbody>
              {this.state.resources.map(resource =>
                <tr><td style={{width: "160px"}} key={resource.id} onClick={() => this.selectResource(resource)} class={this.state.resource.id === resource.id?'react-calendar__tile--active':''}>
                  {resource.name}</td></tr>
              )}
            </tbody></table>
        </SideNav.Nav>
      </SideNav>
    );
  }

  renderResourcesTable() {
    return (
        <div class="tabledivbig">
        <div class="tabledivbtn">

          <table className='table table-striped' aria-labelledby="tabelLabel">
            <thead>
              <tr>
                <th><FormattedMessage id="name"/></th>
                <th><FormattedMessage id="resource_instances"/></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {this.state.resources.map(resource =>
                <tr key={resource.id} onClick={() => this.selectResource(resource)} class={this.state.resource?.id === resource.id?'react-calendar__tile--active':''}>
                  <td>{resource.name}</td>
                  <td>{resource.count}</td>
                  <td>{resource.assigned?<></>:<><div style={{color: "red"}}><FormattedMessage id="noservices"/></div> <a href="#" onClick={(e) => this.selectResourceAndScroll(e, resource)}><FormattedMessage id="addservices"/></a></>}</td>
                </tr>
              )}
            </tbody>
          </table>

        </div>
        <input style={{marginTop: "5px"}} class="btn btn-primary" disabled={this.state.resource?.id===0} type="button" value={this.props.intl.formatMessage({id: "new"})} id="Button_New" onClick={this.handleNew}/>
        </div>
    );
  }

  renderResourcesParams() {
    const regionStyle = {
      background: "rgba(0, 0, 255, 0.5)",
      zIndex: 99
    };
    return (
      <div>
        <div class="form-group">
          <label for="Input_ResourceName"><FormattedMessage id="resource_name"/></label>
          <input class="form-control" type="text" id="Input_ResourceName" name="Input.ResourceName"
            value={this.state.resource.name !== undefined ? this.state.resource.name : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, resource: {...prevState.resource, name: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ResourceDescription"><FormattedMessage id="resource_description"/></label>
          <ReactQuill class="form-control" id="Input_ResourceDescription" name="Input.ResourceDescription"
            value={this.state.resource.description !== undefined ? this.state.resource.description : ''}
            onChange={val => {this.setState(prevState => ({...prevState, resource: {...prevState.resource, description: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ResourceCount"><FormattedMessage id="resource_instances"/></label>
          <input class="form-control" type="text" id="Input_ResourceCount" name="Input.ResourceCount"
            value={this.state.resource.count !== undefined ? this.state.resource.count : '1'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, resource: {...prevState.resource, count: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_BookingProfile"><FormattedMessage id="resource_profile"/></label>
          <select class="form-control" id="Input_BookingProfile" name="Input.BookingProfile"
            value={this.state.resource.profileId ? this.state.resource.profileId.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, resource: {...prevState.resource, profileId: parseInt(val)}}));}}>
              <option value="0"></option>
              {this.state.profiles.map(profile => <option value={profile.id}>{profile.name}</option>)}
          </select>
        </div>
        {this.state.resource.id > 0 ? (
          <><div class="form-group">
            <div><FormattedMessage id="photo"/></div>
            <div className="imagesq schemecomp">
              {this.state.resource.images.length > 0 ? <div className="removeimage" onClick={() => this.removeImage()}>X</div> : <></>}
              {this.state.selectedImage > 0 ? <div className="upimage" onClick={() => this.upImage()}>&uarr;</div> : <></>}
              {this.state.selectedImage >= 0 && this.state.selectedImage < this.state.resource.images.length ? <img src={this.state.resource.images[this.state.selectedImage]} alt="" class="schemecomp"/> : <></>}
            </div>
          </div>
          <div class="tablediv">
            <label for="file-upload" class="btn btn-primary">
              <i class="fa fa-cloud-upload"></i> <FormattedMessage id="upload_photo"/>
            </label>
            <input id="file-upload" onChange={this.addFile.bind(this)} type="file"/>
          </div></>
        ) : <></>}
        <div class="form-group">
          <label for="Input_ResourceMap"><FormattedMessage id="resource_map_location"/></label>
          <select class="form-control" id="Input_ResourceMap" name="Input.ResourceMap"
            value={this.state.resource.mapId ? this.state.resource.mapId.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, resource: {...prevState.resource, mapId: parseInt(val)}}));}}>
              <option value="0"></option>
              {this.state.resource.companyImages.map((img, i) => <option value={(i+1).toString()}>{img}</option>)}
          </select>
        </div>
        <div>
          <label for="Input_ResourceLoc"><FormattedMessage id="resource_location"/></label>
          <input disabled class="form-control" type="text" id="Input_ResourceLoc" name="Input.ResourceLoc" value={this.state.resource.locationX !== null ? this.state.resource.locationX.toString()+','+this.state.resource.locationX.toString()+','+this.state.resource.locationWidth.toString()+','+this.state.resource.locationHeight.toString() : ''} onChange={evt => this.updateResourceLocation(evt)}/>
          {this.state.resource.mapId && this.state.resource.mapId > 0 ? (
            <ReactRegionSelect
              maxRegions={1}
              regions={this.state.regions}
              regionStyle={regionStyle}
              onChange={this.onRegionChange}>
              <img src={this.state.resource.companyImages[parseInt(this.state.resource.mapId) - 1]} class="schemeimg"/>
            </ReactRegionSelect>
          ) : <></>}
        </div>
        <div class="tablediv">
          <input class="btn btn-primary" type="button" value={this.state.resource.id === 0 ? this.props.intl.formatMessage({id: "create"}) : this.props.intl.formatMessage({id: "save"})} id="Button_Save" onClick={this.handleSave}/>
        </div>
      </div>
    );
  }

  renderServicesTable() {
    return (
      <><div id="configservices" class="tablediv">

      <div><FormattedMessage id="resource_services"/></div>
      <table className='table table-striped' aria-labelledby="tabelLabel">
        <thead>
          <tr>
            <th><FormattedMessage id="name"/></th>
            <th><FormattedMessage id="assigned"/></th>
            <th><FormattedMessage id="price"/></th>
            <th><FormattedMessage id="min_time"/></th>
            <th><FormattedMessage id="max_time"/></th>
            <th style={{display: "none"}}><FormattedMessage id="editable"/></th>
          </tr>
        </thead>
        <tbody>
          {this.state.services.map(service =>
            <tr key={service.id} onClick={() => this.selectService(service)} class={this.state.service?.id === service.id?'react-calendar__tile--active':''}>
              <td>{service.name}</td>
              <td onClick={() => this.assignResource(service)}>{service.assigned ? "✔" : ''}</td>
              <td>{service.price}</td>
              <td>{service.minTime}</td>
              <td>{service.maxTime}</td>
              <td style={{display: "none"}}>{service.timeEditable ? '✔' : ''}</td>
            </tr>
          )}
        </tbody>
      </table>

      </div>

              {this.state.service === null || !this.state.service.assigned?<></>:
        <><div class="form-group">
          <label for="Input_ServiceName"><FormattedMessage id="service_name"/></label>
          <input class="form-control" disabled={true} type="text" id="Input_ServiceName" name="Input.ServiceName"
            value={this.state.service.name ? this.state.service.name : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, name: val}}));}}/>
        </div>
        <div class="form-group">
          <label for="Input_ServicePrice"><FormattedMessage id="service_price"/></label>
          <input class="form-control" type="text" id="Input_ServicePrice" name="Input.ServicePrice"
            value={this.state.service.price !== undefined ? this.state.service.price : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, price: val.length>0?val:null}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ServiceMinTime"><FormattedMessage id="service_min_duration"/></label>
          <input class="form-control" type="text" id="Input_ServiceMinTime" name="Input.ServiceMinTime"
            value={this.state.service.minTime !== undefined ? this.state.service.minTime : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, minTime: val.length>0?val:null}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ServiceMaxTime"><FormattedMessage id="service_max_duration"/></label>
          <input class="form-control" type="text" id="Input_ServiceMaxTime" name="Input.ServiceMaxTime"
            value={this.state.service.maxTime !== undefined ? this.state.service.maxTime : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, maxTime: val.length>0?val:null}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_BookingInterval"><FormattedMessage id="service_interval"/></label>
          <select class="form-control" id="Input_BookingInterval" name="Input.BookingInterval"
            value={this.state.service.bookingInterval ? this.state.service.bookingInterval.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, bookingInterval: val}}));}}>
              <option value="1"><FormattedMessage id="interval_min"/></option>
              <option value="2"><FormattedMessage id="interval_5min"/></option>
              <option value="3"><FormattedMessage id="interval_hour"/></option>
              <option value="4"><FormattedMessage id="interval_day"/></option>
          </select>
        </div>
        <div class="form-group">
          <label for="Input_PartialBooking"><FormattedMessage id="partial_booking"/></label>
          <select class="form-control" id="Input_PartialBooking" name="Input.PartialBooking"
            value={this.state.service.partialBooking ? this.state.service.partialBooking.toString() : 'null'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, partialBooking: val === 'null' ? null : val}}));}}>
              <option value="null"><FormattedMessage id="partial_off"/></option>
              <option value="2">2 <FormattedMessage id="partials_2_4_members"/></option>
              <option value="2">2 <FormattedMessage id="partials_2_4_members"/></option>
              <option value="3">3 <FormattedMessage id="partials_2_4_members"/></option>
              <option value="4">4 <FormattedMessage id="partials_2_4_members"/></option>
              <option value="5">5 <FormattedMessage id="partials_5_10_members"/></option>
              <option value="6">6 <FormattedMessage id="partials_5_10_members"/></option>
              <option value="7">7 <FormattedMessage id="partials_5_10_members"/></option>
              <option value="8">8 <FormattedMessage id="partials_5_10_members"/></option>
              <option value="9">9 <FormattedMessage id="partials_5_10_members"/></option>
              <option value="10">10 <FormattedMessage id="partials_5_10_members"/></option>
          </select>
        </div>
        <div class="form-group">
          <label for="Input_Prepayment"><FormattedMessage id="prepayment_amount"/></label>
          <input class="form-control" type="text" id="Input_Prepayment" name="Input.Prepayment"
            value={this.state.service.prepayment !== undefined ? this.state.service.prepayment : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, prepayment: val.length>0?val:null}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_Cancelation"><FormattedMessage id="service_cancelation"/></label>
          <input class="form-control" type="text" id="Input_Cancelation" name="Input.Cancelation"
            value={this.state.service.cancelation !== undefined ? this.state.service.cancelation : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, service: {...prevState.service, cancelation: val.length>0?val:null}}));}}
          />
        </div>
        <input style={{marginTop: "5px"}} class="btn btn-primary" type="button" value={this.props.intl.formatMessage({id: "save"})} id="Button_Save" onClick={() => this.handleSaveService(this.state.service)}/>
        </>}
</>
    );
  }

  async setOptional(val, resourceParam) {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/resourceparamoptional/${this.state.companyId}/${this.state.resource.id}/${resourceParam.id}?value=${val}`, {
      method: "PUT",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      }
    });
    await response.json();
    const resources = this.state.resources;
    const resource = this.state.resource;

    resources.forEach(res => {
      if (res.id === this.state.resource.id) {
        res.params.forEach(param => {
          if (param.id === resourceParam.id) {
            param.optional = val;
          }
        });
      }
    });
    resource.params.forEach(param => {
      if (param.id === resourceParam.id) {
        param.optional = val;
      }
    });
    this.setState(prevState => ({...prevState, resources: resources, resource: resource}));
  }

  renderParamOptions(paramGroup, param, resourceParam) {
    return (
      <>
      <h4>{paramGroup.name} ({param.name})</h4>
        <div>
          <input style={{margin: "5px 5px 0 0"}} class="form-check-input" type="checkbox" id="Input_Optional" name="Input.Optional"
            checked={resourceParam.optional !== undefined ? resourceParam.optional : false}
            onChange={evt => {const val = evt.target.checked; this.setOptional(val, resourceParam);}}
          />
          <label style={{display: "contents"}} for="Input_Optional"><FormattedMessage id="param_optional"/></label>
        </div>

<div class="tablediv">

      <div><FormattedMessage id="resource_services"/></div>
      <table className='table table-striped' aria-labelledby="tabelLabel">
        <thead>
          <tr>
            <th><FormattedMessage id="name"/></th>
            <th><FormattedMessage id="price"/></th>
            <th><FormattedMessage id="min_time"/></th>
            <th><FormattedMessage id="max_time"/></th>
            <th style={{display: "none"}}><FormattedMessage id="editable"/></th>
          </tr>
        </thead>
        <tbody>
          {this.state.services.filter(service => service.assigned).map(service =>
            <tr key={service.id} onClick={() => this.selectParamService(service, param)} class={this.state.paramservice?.id === service.id?'react-calendar__tile--active':''}>
              <td>{service.name}</td>
              <td>{service.price}</td>
              <td>{service.minTime}</td>
              <td>{service.maxTime}</td>
              <td style={{display: "none"}}>{service.timeEditable ? '✔' : ''}</td>
            </tr>
          )}
        </tbody>
      </table>

      </div>
        <div class="form-group">
          <label for="Input_BookingProfile_Filter"><FormattedMessage id="resource_profile"/></label>
          <select class="form-control" id="Input_BookingProfile_Filter" name="Input.BookingProfile.Filter"
            value={this.state.param.profileId ? this.state.param.profileId.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, param: {...prevState.param, profileId: parseInt(val)}}));}}>
              <option value="0"></option>
              {this.state.profiles.map(profile => <option value={profile.id}>{profile.name}</option>)}
          </select>
        </div>

        <div class="form-group">
          <label for="Input_ServicePrice_Filter"><FormattedMessage id="service_price"/></label>
          <input class="form-control" type="text" id="Input_ServicePrice_Filter" name="Input.ServicePrice.Filter"
            value={this.state.param.price !== undefined ? this.state.param.price : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, param: {...prevState.param, price: val.length>0?val:null}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ServiceMinTime_Filter"><FormattedMessage id="service_min_duration"/></label>
          <input class="form-control" type="text" id="Input_ServiceMinTime_Filter" name="Input.ServiceMinTime.Filter"
            value={this.state.param.minTime !== undefined ? this.state.param.minTime : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, param: {...prevState.param, minTime: val.length>0?val:null}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ServiceMaxTime_Filter"><FormattedMessage id="service_max_duration"/></label>
          <input class="form-control" type="text" id="Input_ServiceMaxTime_Filter" name="Input.ServiceMaxTime.Filter"
            value={this.state.param.maxTime !== undefined ? this.state.param.maxTime : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, param: {...prevState.param, maxTime: val.length>0?val:null}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_BookingInterval_Filter"><FormattedMessage id="service_interval"/></label>
          <select class="form-control" id="Input_BookingInterva_Filterl" name="Input.BookingInterval.Filter"
            value={this.state.param.bookingInterval ? this.state.param.bookingInterval.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, param: {...prevState.param, bookingInterval: val}}));}}>
              <option value="1"><FormattedMessage id="interval_min"/></option>
              <option value="2"><FormattedMessage id="interval_5min"/></option>
              <option value="3"><FormattedMessage id="interval_hour"/></option>
              <option value="4"><FormattedMessage id="interval_day"/></option>
          </select>
        </div>
        <div class="form-group">
          <label for="Input_PartialBooking_Filter"><FormattedMessage id="partial_booking"/></label>
          <select class="form-control" id="Input_PartialBooking_Filter" name="Input.PartialBooking.Filter"
            value={this.state.param.partialBooking ? this.state.param.partialBooking.toString() : 'null'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, param: {...prevState.param, partialBooking: val === 'null' ? null : val}}));}}>
              <option value="null"><FormattedMessage id="partial_off"/></option>
              <option value="2">2 <FormattedMessage id="partials_2_4_members"/></option>
              <option value="3">3 <FormattedMessage id="partials_2_4_members"/></option>
              <option value="4">4 <FormattedMessage id="partials_2_4_members"/></option>
              <option value="5">5 <FormattedMessage id="partials_5_10_members"/></option>
              <option value="6">6 <FormattedMessage id="partials_5_10_members"/></option>
              <option value="7">7 <FormattedMessage id="partials_5_10_members"/></option>
              <option value="8">8 <FormattedMessage id="partials_5_10_members"/></option>
              <option value="9">9 <FormattedMessage id="partials_5_10_members"/></option>
              <option value="10">10 <FormattedMessage id="partials_5_10_members"/></option>
          </select>
        </div>
        <input style={{marginTop: "5px"}} disabled={!this.state.paramservice} class="btn btn-primary" type="button" value={this.props.intl.formatMessage({id: "save"})} id="Button_Save" onClick={() => this.handleSaveFilterService(param)}/>
      </>
    );
  }

  renderResourceParams() {
    return (
      <div class="tablediv">
        <div><FormattedMessage id="resource_params"/></div>
        {this.state.filters.map(group =>
          <div>{group.name?<label>{group.name}</label>:<></>}<table class="table-filter2"><tr>{group.items.map(param => 
            <>
              <td key={param.id} onClick={() => this.addFilter(param.id, group.id)} className={this.state.resource.params.map(p => p.id).includes(param.id)?'react-calendar__tile--active filternamesel':'filtername'}>{param.name}</td>
              {this.state.resource.params.map(p => p.id).includes(param.id) && this.state.services.filter(s => s.assigned).length > 0 ? <Popup
                className="popup-info"
                trigger={open => <td class="filteroptsel"></td>}
                position="bottom center"
                onOpen={() => this.selectParamService(this.state.services.filter(s => s.assigned)[0], param)}
                closeOnDocumentClick>{() => this.renderParamOptions(group, param, this.state.resource.params.filter(p => p.id === param.id)?.[0])}</Popup> : <td class="filteropt"></td>}
            </>
          )}{this.state.curparamgroup === group.id ? 
            <td><input style={{border: "0"}} type="text" id="Input_GroupValue" name="Input.GroupValue"
              value={this.state.newgroupvalue !== undefined ? this.state.newgroupvalue : ''}
              onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, newgroupvalue: val}));}}
            /></td>
            : <></>}
            {this.state.curparamgroup === group.id ? <td onClick={() => this.saveGroupValue(group.id)}>&#10004;</td> : <td onClick={() => this.setState(prevState => ({...prevState, curparamgroup: group.id}))}>+</td>}
            </tr></table></div>
        )}
        <div>
          <label for="Input.GroupName"><FormattedMessage id="create_group"/></label>
          <input style={{margin: "8px 0px 4px 5px"}} class="form-control form-control-inline" type="text" id="Input_GroupName" name="Input.GroupName"
            value={this.state.newgroupname !== undefined ? this.state.newgroupname : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, newgroupname: val}));}}
          />
          <input style={{margin: "8px 0px 4px 0px", border: "1px solid #d3d3d3"}} class="btn" type="button" value="&#10004;" id="Button_New" onClick={this.handleNewGroup}/>
        </div>
      </div>
    );
  }

  render() {
    let contents = this.state.loading
      ? <p><em><FormattedMessage id="loading"/></em></p>
      : this.renderResourcesTable();

    let serviceContents = !this.state.resource?.id
      ? <></>
      : this.renderServicesTable();

    let paramsContents = !this.state.resource?.id
      ? <></>
      : this.renderResourceParams();

    return (
      <div class="sidenav-container-div">
        <ConfigMenu {...this.props} companyId={this.state.companyId} selected="resources" />
        <div>
        {this.state.resource ? this.renderRightPanel() : <></>}
        <div class="headerdiv"><h4 id="tabelLabel"><FormattedMessage id="config_resources"/></h4></div>
        <div class="centerpanel"><div><FormattedMessage id="resources_list"/></div>
        <div class="configcolumns">
        <div class="leftpane">
        {contents}
        </div>
        {this.state.resource === null ? <></> :
        <div class="rightpane">
        {this.renderResourcesParams()}
        {paramsContents} 
        {serviceContents}
        </div>}
        </div></div></div>
      </div>
    );
  }

  async populateResourcesData(companyId) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/${companyId}/resources`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, resources: data, loading: false}));
    this.populateProfilesData(companyId);
  }

  async populateServicesData(companyId) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/${companyId}/${this.state.resource.id}/services`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, services: data, loading: false}));
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (this.state.companies.length > 0)
    {
      const ownCompanies = this.state.companies.filter(c => this.state.companyId === 0 || c.id === this.state.companyId);
      if (ownCompanies.length > 0) {
        this.setState(prevState => ({...prevState, companyId: ownCompanies[0].id}));
        this.populateResourcesData(ownCompanies[0].id);
        this.populateFiltersData();
      } else {
        window.location.replace(`/configcompany/${this.state.companyId}`);
      }
    }
  }

  async populateFiltersData(serviceId) {
    const token = await authService.getAccessToken();
    const url = `{{mainApiUrl}}api/companies/resourceparamgroups/${this.state.companyId}`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, filters: data}));
  }

  async populateProfilesData(companyId) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/${companyId}/profiles`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, profiles: data, loading: false}));
  }
})